<template>
  <!--<div>
    <v-table>
      <thead>
        <tr>
          <th>
            ID
          </th>
          <th>Cancer Type</th>
          <th>MTB Registration</th>
          <th>MTB Conference</th>
          <th>Interpretation</th>
          <th>Biomarkers</th>
          <th>Recommendation</th>
          <th>Patient Details</th>
          <th class="text-center">MTB Presentation</th>
        </tr>
      </thead>
      <tbody>
        <tr class="align-middle items-center" v-for="(item, k) in this.$store.getters.idList" v-bind:key="k">
          <td class="text-left">{{ item.id }}</td>
          <td class="text-left">{{ item.cancer_type }}</td>
          <td class="text-left">{{ item.mtb_registration_date }}</td>
          <td class="text-left">{{ item.mtb_conference_date }}</td>
          <td>
            <v-btn>Run</v-btn>
          </td>
          <td></td>
          <td></td>
          <td>
            <a href="">
              <router-link :to="`/show-id/${item.id}`">
                <v-btn elevation="2">
                  <span>Show Patient</span>
                </v-btn>
              </router-link>
            </a>
          </td>
          <td class="text-center">
            <v-btn disabled class="mark_button" @click="togglePresentation(item)"
              :class="{ 'already_added': item.id in presentation_patients }">
              {{ item.id in presentation_patients ? 'Selected' : 'Select' }}
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-table>

    <Loading v-model:active="isLoading" v-model="fullPage" :can-cancel="true" :on-cancel="onCancel"
      :is-full-page="fullPage" />
  </div>-->
  <Table_Patient table_id="mtb_patient_table"/>
</template>

<script setup lang="js">
import 'vue-loading-overlay/dist/css/index.css';
import id_requests from "@/methods/id_requests";
import { useStore } from 'vuex';
import { ref, onMounted, computed } from 'vue';
import Table_Patient from '@/components/tables/Table_Patient.vue';

const store = useStore();
const presentation_patients = computed(() => store.state.presentation_selected_patients);
const current_mtb = computed(() => store.state.current_mtb);

/**
 * @prop websocket - A websocket that can be passed down from App.vue. If no websocket connection exists, it is null.
 */
const props = defineProps({
  websocket: WebSocket | null,
})

/**
 * The following steps are performed if the MTB Patient list is loaded:
 * 1. All patients that belong to the current MTB are loaded.
 */
onMounted(async () => {

  // get all MTB conferences
  await

  await id_requests.getMTBData(current_mtb.value);
  store.dispatch("setIDList", store.state.mtb_data[current_mtb.value]);
  fetchPatients();
})

/**
 * Loads patient data (for the current MTB) from store and filters them.
 * Then saves it in a dedicated presentation_all_patients variable.
 */
const fetchPatients = () => {
  var all_patients_raw = store.getters.idList;
  if (all_patients_raw !== undefined) {
    Object.keys(all_patients_raw).map(key => {
      delete all_patients_raw[key]['id'];
      all_patients_raw[key]['id'] = String(key);
    })
    store.dispatch('setPresentationAllPatients', all_patients_raw);
  }
}

/**
 * Toggles whether a patient is selected or not. Currently deactivated.
 * @param {Object} patient_object - Object containing relevant patient data
 */
const togglePresentation = (patient_object) => {
  store.dispatch('togglePresentationPatientSelected', patient_object);
}
const isLoading = ref(false);
</script>

<style>
.mark_button {
  width: 60%;
}

.already_added {
  background-color: #45f248 !important;
  color: white !important;
}
</style>